let f = true;

function caricaMenuGeCo(u, t, c, l, a, s) {
  if (f) {
    f = false;
    const e = document.createElement('script');
    e.type = 'text/javascript';
    e.src = `${u}/App/dist/browser-export.js`;
    e.async = false;
    e.defer = false;
    e.onload = function onload() {
      window.GeCo.inizializzaMenu(u, t, c, l, a, s);
    };
    const h = document.getElementsByTagName('head')[0];
    h.insertBefore(e, h.lastChild);
  }
}

let menuPluginCaricato = true;

function caricaMenuPluginGeCo(url, utente, ufficio, container, urlHelpdesk, origineAperturaModaleQuesito, area, servizio) {
  if (menuPluginCaricato) {
    menuPluginCaricato = false;
    const e = document.createElement('script');
    e.type = 'text/javascript';
    e.src = `${url}/App/dist/browser-export.js`;
    e.async = false;
    e.defer = false;
    e.onload = function onload() {
      window.GeCo.inizializzaMenuPlugin(url, utente, ufficio, container, urlHelpdesk, origineAperturaModaleQuesito, area, servizio);
    };
    const h = document.getElementsByTagName('head')[0];
    h.insertBefore(e, h.lastChild);
  }
}

module.exports = {
  inizializza(u, t, c, l, a, s) {
    setTimeout(() => caricaMenuGeCo(u, t, c, l, a, s));
  },
  inizializzaMenuPlugin(url, utente, ufficio, container, urlHelpdesk, origineAperturaModaleQuesito, area, servizio) {
    setTimeout(() => caricaMenuPluginGeCo(url, utente, ufficio, container, urlHelpdesk, origineAperturaModaleQuesito, area, servizio));
  },
  cambiaUfficio(u) {
    window.GeCo && window.GeCo.cambiaUfficio && window.GeCo.cambiaUfficio(u);
  },
  impostaAreaSelezionata(a) {
    window.GeCo && window.GeCo.impostaAreaSelezionata && window.GeCo.impostaAreaSelezionata(a);
  },
  impostaServizioCorrente(a) {
    window.GeCo && window.GeCo.impostaServizioCorrente && window.GeCo.impostaServizioCorrente(a);
  },

  /**
   * Crea un nuovo quesito passando le informazioni necessarie.
   * @param {{categoria, oggetto, messaggio}} props
   */
  creaNuovoQuesito(props) {
    window.GeCo && window.GeCo.creaNuovoQuesito && window.GeCo.creaNuovoQuesito(props);
  },
};
